import Core from '@/libs/src/core'

const test = function(a){
    // let Core = window.$Core;

    let Auth = Core.getProvider('Auth')
    let device = Auth.device;
    let mqtt = Core.getProvider('MQTT')
    // window.topology.mqttClient.publish(device.deviceNo)
    mqtt.sendMsg({
        "uuid":device.deviceNo,
        "action":"readdata",
        "ts":new Date(),
        "data":"alldata"
      })
    mqtt.on('subscribe.success',(data)=>{
      console.log('数据',data)
    })

}

export default test;